export default "__VITE_ASSET__PR0KpScF__"